import Icon from "assets/icons";
import InventoryType from "shared/enums/InventoryType";

export function getInventoryTypeIcon(inventoryType: InventoryType) {
  switch (inventoryType) {
    case InventoryType.MEETING:
    case InventoryType.BUNDLED_MEETING:
    case InventoryType.MEETING_CHARGE:
    case InventoryType.BUNDLED_MEETING_CHARGE:
      return <Icon.InPerson />;
    case InventoryType.BULK_TICKET:
    case InventoryType.BULK_TICKET_CHARGE:
    case InventoryType.TICKET:
    case InventoryType.TICKET_CHANGE:
    case InventoryType.TICKET_CHARGE:
    case InventoryType.TICKET_UPGRADE:
      return <Icon.ManageTicket />;
    case InventoryType.ADD_ONS:
    case InventoryType.ADD_ONS_CHARGE:
      return <Icon.AddOns />;
    default:
      return null;
  }
}
